import {
  apiLoadMortalityRate,
  apiLoadMortalityAOG,
  apiLoadMortalityDirect,
  apiLoadMortalityTimingOfDeath,
  apiLoadMortalityPregnancyType,
  apiLoadIndicationForCS,
  apiLoadIndicationDeliveryManner,
  apiLoadDeliveryManner,
  apiLoadAOG,
  apiLoadPregnancyType
} from '../api/apiObservables';
import apiHelper from '../../utilities/apiObsHelpers'
import { remap } from "../../utilities/utilityOperators";

export const GETTER_MORTALITY_RATE = 'analytics/mortality/getRate';
export const GETTER_MORTALITY_AGE = 'analytics/mortality/getAge';
export const GETTER_MORTALITY_AOG = 'analytics/mortality/getAOG';
export const GETTER_MORTALITY_DIRECT = 'analytics/mortality/getDirect';
export const GETTER_MORTALITY_TIMING = 'analytics/mortality/getTiming';
export const GETTER_MORTALITY_PREGNANCY_TYPE = 'analytics/mortality/getPregnancyType';

export const GETTER_DELIVERY_MANNER    = 'analytics/cases/getdeliverymanner';
export const GETTER_INDICATIONS_FOR_CS = 'analytics/cases/getindicationsforcs';
export const GETTER_PREGNANCY_TYPE = 'analytics/mortality/getAllPregnancyType';
export const GETTER_AOG = 'analytics/cases/getAOG';



export const MUTATE_MORTALITY_RATE = 'analytics/mortality/mutateRate';
export const MUTATE_MORTALITY_AGE = 'analytics/mortality/mutateAge';
export const MUTATE_MORTALITY_AOG = 'analytics/mortality/mutateAOG';
export const MUTATE_MORTALITY_DIRECT = 'analytics/mortality/mutateDirect';
export const MUTATE_MORTALITY_TIMING = 'analytics/mortality/mutateTiming';
export const MUTATE_MORTALITY_PREGNANCY_TYPE = 'analytics/mortality/mutatePregnancyType';

export const MUTATE_DELIVERY_MANNER    = 'analytics/cases/mutatedeliverymanner';
export const MUTATE_INDICATIONS_FOR_CS = 'analytics/cases/mutateindicationsforcs';
export const MUTATE_AOG = 'analytics/cases/mutateAOG';
export const MUTATE_PREGNANCY_TYPE = 'analytics/mortality/mutateAllPregnancyType';

export const ACTION_LOAD_MORTALITY_RATE = 'analytics/mortality/loadRate';
export const ACTION_LOAD_MORTALITY_AGE = 'analytics/mortality/loadAge';
export const ACTION_LOAD_MORTALITY_AOG = 'analytics/mortality/loadAOG';
export const ACTION_LOAD_MORTALITY_DIRECT = 'analytics/mortality/loadDirect';
export const ACTION_LOAD_MORTALITY_TIMING = 'analytics/mortality/loadTiming';
export const ACTION_LOAD_PREGNANCY_TYPE = 'analytics/mortality/loadPregnancyType';

export const ACTION_LOAD_DELIVERY_MANNER    = 'analytics/cases/loaddeliverymanner';
export const ACTION_LOAD_INDICATIONS_FOR_CS = 'analytics/cases/loadindicationsforcs';
export const ACTION_LOAD_AOG                = 'analytics/cases/loadAOG';
export const ACTION_LOAD_ALL_PREGNANCY_TYPE = 'analytics/mortality/loadAllPregnancyType';

const state = {
  rate:{
    id    : '1230',
    title : 'Maternal Mortality Rate',
    chart: 'pie',
    data  :{
      color: ['#00CFE6','#E85F70'],
      title:{
        value: 0
      },
      values: [],
      footnote:{
        value: 0,
        label: 'No. of Cases'
      }
    }
  },
  age:{
    id    : '1231',
    title : 'Average Age',
    chart : 'pie',
    data  :{
      color: '#00CFE6',
      title:{
        value: 0,
        label: 'Years'
      },
      values: [],
      labels: [
        'Less than 20',
        '20 to 34',
        '35 and Above'
      ]
    }
  },
  aog:{
    id    : '1232',
    title : 'Age of Gestation',
    chart : 'bar',
    data  :{
      color: '#00E5B7',
      title:{
      },
      values: [],
      labels: [
        'Less than 28 weeks',
        '28 to 32 weeks',
        '33 to 37 weeks',
        '38 to 42 weeks'
      ]
    }
  },
  direct:{
    id    : '1233',
    title : 'Direct Maternal Deaths',
    chart : 'pie',
    data  :{
      color: ['#0090F5','#00B3FF','#00CFE6','#00E5B7','#93F388','#F9F871'],
      title:{
        value: 0
      },
      values: [],
      labels: [
        'Hemmorhage',
        'Hypertension',
        'Infection',
        'Vascular Accidents',
        'Anesthesia',
        'Others'
      ]
    }
  },
  timing:{
    id    : '1238',
    title : 'Mortality Based on Timing of Death',
    chart : 'bar',
    data  :{
      color: '#826DC9',
      values: [],
      labels: [
        'Antepartal',
        'Intrapartal',
        'Postpartal',
        'Puerparal',
      ]
    }
  },
  pregnancyType:{
    id    : '1239',
    title : 'Pregnancy Type',
    chart : 'bar',
    data  :{
      color: '#9A4276',
      values: [],
      labels: [
        'Singleton',
        'Multiple',
        'Miscarriage',
        'Ectopic',
        'Molar'
      ]
    }
  },
  indicationForCS:{
    id    : '1240',
    title : 'Indication for CS',
    chart : 'bar-vertical',
    data  :{
      color: ['#47389c',
              '#4b3ba6',
              '#4f3eaf',
              '#5341b9',
              '#5a47bf',
              '#6250c3',
              '#6b5ac6',
              '#7363ca',
              '#7b6ccd',
              '#8475d1',
              '#8c7fd4',
              '#9588d8',
              '#9d92db',
              '#a69bde',
              '#aea4e2',
              '#b7aee5',
              '#bfb7e8',
              '#c8c1eb',
              '#d0cbee',
              '#d9d4f2'],
      values: [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20],
      labels: [
        'Dysfunctional Labor',
        'Fetal Distress',
        'Malpresentation',
        'Fetal Indication',
        'Repeat',
        'Maternal request',
        'Multiple gestation',
        'Labor dystocia',
        'Abnormal/indeterminate fetal heart rate tracing',
        'Prevention of trauma',
        'Suspected fetal macrosomia',
        'Malignancies in lower genital tract',
        'Large vulvovaginal condylomas',
        'Obstructive vaginal septa',
        'Leiomyomas of the lower uterine segment',
        'Pelvic abnormalities',
        'Congenital malformations / skeletal disorders',
        'Infection',
        'Prolonged acidemia',
        'Cephalopelvic disproportion',
      ]
    }
  },
  deliveryManner:{
    id    : '1241',
    title : 'Manner of Delivery',
    chart : 'bar',
    data  :{
      color: '#935DAE',
      values: [],
      labels: [
        'Dysfunctional Labor',
        'Fetal Distress',
        'Malpresentation',
        'Fetal Indication',
        'Repeat',
        'Maternal request',
        'Multiple gestation',
        'Labor dystocia',
        'Abnormal/indeterminate fetal heart rate tracing',
        'Prevention of trauma',
        'Suspected fetal macrosomia',
        'Malignancies in lower genital tract',
        'Large vulvovaginal condylomas',
        'Obstructive vaginal septa',
        'Leiomyomas of the lower uterine segment',
        'Pelvic abnormalities',
        'Congenital malformations / skeletal disorders',
        'Infection',
        'Prolonged acidemia',
        'Cephalopelvic disproportion',
      ]
    }
  },
  aogAll:{
    id    : '1242',
    title : 'Admission Age of Gestations',
    chart : 'bar',
    data  :{
      color: '#9B4E92',
      title:{
      },
      values: [],
      labels: [
        'Less than 28 weeks',
        '28 to 32 weeks',
        '33 to 37 weeks',
        '38 to 42 weeks'
      ]
    }
  },
};

const getters = {
  [GETTER_MORTALITY_RATE]: (state) => state.rate,
  [GETTER_MORTALITY_AGE]: (state) => state.age,
  [GETTER_MORTALITY_AOG]: (state) => state.aog,
  [GETTER_MORTALITY_DIRECT]: (state) => state.direct,
  [GETTER_MORTALITY_TIMING]: (state) => state.timing,
  [GETTER_MORTALITY_PREGNANCY_TYPE]: (state) => state.pregnancyType,

  [GETTER_DELIVERY_MANNER]: (state) => state.deliveryManner,
  [GETTER_INDICATIONS_FOR_CS]: (state) => state.indicationForCS,
  [GETTER_AOG]               : (state) => state.aogAll,
  [GETTER_PREGNANCY_TYPE]    : (state) => state.pregnancyType
};

const mutations = {
  // TODO: Custom code to load specific chart data from service
  [MUTATE_INDICATIONS_FOR_CS] : (state,payload) => {
    let remapped = remap(payload);
    state.indicationForCS.data.values = [
      remapped['DysfunctionalLabor'].count,
      remapped['FetalDistress'].count,
      remapped['Malpresentation-Other'].count,
      remapped['Malpresentation-Breech'].count,
      remapped['Malpresentation-TransverseLie'].count,
      remapped['FetalIndication'].count,
      remapped['Repeat'].count,
      remapped['Maternalrequest'].count,
      remapped['Multiplegestation'].count,
      remapped['Labordystocia'].count,
      remapped['Abnormal/indeterminatefetalheartratetracing'].count,
      remapped['Preventionoftrauma'].count,
      remapped['Suspectedfetalmacrosomia'].count,
      remapped['Malignanciesinlowergenitaltract'].count,
      remapped['Largevulvovaginalcondylomas'].count,
      remapped['Obstructivevaginalsepta'].count,
      remapped['Leiomyomasoftheloweruterinesegment'].count,
      remapped['Pelvicabnormalities'].count,
      remapped['Congenitalmalformations/skeletaldisorders'].count,
      remapped['Infection'].count,
      remapped['Prolongedacidemia'].count,
      remapped['Cephalopelvicdisproportion'].count,
      remapped['ObstetricHemorrhage'].count
    ];
    state.indicationForCS.data.labels = [
      remapped['DysfunctionalLabor'].label,
      remapped['FetalDistress'].label,
      remapped['Malpresentation-Other'].label,
      remapped['Malpresentation-Breech'].label,
      remapped['Malpresentation-TransverseLie'].label,
      remapped['FetalIndication'].label,
      remapped['Repeat'].label,
      remapped['Maternalrequest'].label,
      remapped['Multiplegestation'].label,
      remapped['Labordystocia'].label,
      remapped['Abnormal/indeterminatefetalheartratetracing'].label,
      remapped['Preventionoftrauma'].label,
      remapped['Suspectedfetalmacrosomia'].label,
      remapped['Malignanciesinlowergenitaltract'].label,
      remapped['Largevulvovaginalcondylomas'].label,
      remapped['Obstructivevaginalsepta'].label,
      remapped['Leiomyomasoftheloweruterinesegment'].label,
      remapped['Pelvicabnormalities'].label,
      remapped['Congenitalmalformations/skeletaldisorders'].label,
      remapped['Infection'].label,
      remapped['Prolongedacidemia'].label,
      remapped['Cephalopelvicdisproportion'].label,
      remapped['ObstetricHemorrhage'].label,
    ];
  },
  [MUTATE_DELIVERY_MANNER] : (state,payload) => {
    let remapped = remap(payload);
    state.deliveryManner.data.values = [
      remapped['CaesareanSection'].count,
      remapped['SpontaneousCephalic'].count,
      remapped['SpontaneousBreech'].count,
      remapped['PartialBreechExtraction'].count,
      remapped['AssistedVaginalDelivery-Forceps'].count,
      remapped['AssistedVaginalDelivery-Vacuum'].count,
    ];
    state.deliveryManner.data.labels = [
      remapped['CaesareanSection'].label,
      remapped['SpontaneousCephalic'].label,
      remapped['SpontaneousBreech'].label,
      remapped['PartialBreechExtraction'].label,
      remapped['AssistedVaginalDelivery-Forceps'].label,
      remapped['AssistedVaginalDelivery-Vacuum'].label
    ];
  },
  [MUTATE_AOG] : (state,payload) => {
    let remapped = remap(payload);
    state.aogAll.data.values = [remapped["less28"].count,
                             remapped["28-32"].count,
                             remapped["33-36"].count,
                             remapped["37-41"].count,
                             remapped["42more"].count];
    state.aogAll.data.labels = [remapped["less28"].label,
                             remapped["28-32"].label,
                             remapped["33-36"].label,
                             remapped["37-41"].label,
                             remapped["42more"].label,];
  },
  [MUTATE_MORTALITY_RATE] : (state, payload) => {
    let remapped = remap(payload);
    let total = remapped["Dead"].count + remapped["Alive"].count
    state.rate.data.values = [remapped["Alive"].count + remapped["Sick"].count, remapped["Dead"].count];
    state.rate.data.title.value = total > 0 ? parseFloat(remapped["Dead"].count / total * 100).toFixed(0) + "%" : "0%";
    state.rate.data.footnote.value = remapped["Alive"].count + remapped["Sick"].count + remapped["Dead"].count;
  },
  [MUTATE_MORTALITY_AOG] : (state, payload) => {
    let remapped = remap(payload)["Dead"];
    let totals = Object.keys(remapped.cross).reduce((acc,key) => {
      let v = remapped.cross[key];
      acc.count = acc.count + v.count;
      acc.total = acc.total + v.total;
      return acc;
    },{count:0, total:0})
    //state.aog.data.title.value = totals.count > 0 ? parseFloat(totals.total/totals.count).toFixed(0) : "--";
    state.aog.data.values = [remapped.cross["less28"].count,
                             remapped.cross["28-32"].count,
                             remapped.cross["33-36"].count,
                             remapped.cross["37-41"].count,
                             remapped.cross["42more"].count];
    state.aog.data.labels = [remapped.cross["less28"].label,
                              remapped.cross["28-32"].label,
                              remapped.cross["33-36"].label,
                              remapped.cross["37-41"].label,
                             remapped.cross["42more"].label,];

  },
  [MUTATE_MORTALITY_DIRECT] : (state, payload) => {
    let remapped = remap(payload)["Dead"];

    state.direct.data.values = [remapped.cross["Hemorrhage"].count,
                                remapped.cross["Hypertension"].count,
                                remapped.cross["Infection"].count,
                                remapped.cross["VascularAccidents"].count,
                                remapped.cross["Anesthesia"].count,
                                remapped.cross["Others"].count];
    state.direct.data.labels = [remapped.cross["Hemorrhage"].label,
                                remapped.cross["Hypertension"].label,
                                remapped.cross["Infection"].label,
                                remapped.cross["VascularAccidents"].label,
                                remapped.cross["Anesthesia"].label,
                                remapped.cross["Others"].label];
    state.direct.data.title.value = Object.keys(remapped.cross).reduce( (acc, key) => acc + remapped.cross[key].count, 0)
  },
  [MUTATE_MORTALITY_TIMING] : (state, payload) => {
    let remapped = remap(payload)["Dead"];
    let chart = state.timing;
    chart.data.values = [remapped.cross["Antepartal"].count,
      remapped.cross["Intrapartal"].count,
      remapped.cross["Postpartal"].count,
      remapped.cross["Puerperal"].count];
    chart.data.labels = [remapped.cross["Antepartal"].label,
      remapped.cross["Intrapartal"].label,
      remapped.cross["Postpartal"].label,
      remapped.cross["Puerperal"].label];
  },
  [MUTATE_MORTALITY_PREGNANCY_TYPE] : (state, payload) => {
    let remapped = remap(payload)["Dead"];
    let chart = state.pregnancyType;
    chart.data.values = [remapped.cross["Singleton"].count,
                         remapped.cross["Multiple"].count,
                         remapped.cross["Miscarriage"].count,
                         remapped.cross["Ectopic"].count,
                         remapped.cross["Molar"].count];
    chart.data.labels = [remapped.cross["Singleton"].label,
                         remapped.cross["Multiple"].label,
                         remapped.cross["Miscarriage"].label,
                         remapped.cross["Ectopic"].label,
                         remapped.cross["Molar"].label];
  },
  [MUTATE_PREGNANCY_TYPE] : (state, payload) => {
    let remapped = remap(payload);
    let chart = state.pregnancyType;
    chart.data.values = [remapped["Singleton"].count,
                         remapped["Multiple"].count,
                         remapped["Miscarriage"].count,
                         remapped["Ectopic"].count,
                         remapped["Molar"].count];
    chart.data.labels = [remapped["Singleton"].label,
                         remapped["Multiple"].label,
                         remapped["Miscarriage"].label,
                         remapped["Ectopic"].label,
                         remapped["Molar"].label];
  }
};

const actions = {
  [ACTION_LOAD_MORTALITY_RATE] : apiHelper.mutateResult(
    apiLoadMortalityRate,
    MUTATE_MORTALITY_RATE ),
  [ACTION_LOAD_MORTALITY_AOG] : apiHelper.mutateResult(
    apiLoadMortalityAOG,
    MUTATE_MORTALITY_AOG ),
  [ACTION_LOAD_MORTALITY_DIRECT] : apiHelper.mutateResult(
    apiLoadMortalityDirect,
    MUTATE_MORTALITY_DIRECT ),
  [ACTION_LOAD_MORTALITY_TIMING] : apiHelper.mutateResult(
    apiLoadMortalityTimingOfDeath,
    MUTATE_MORTALITY_TIMING ),
  [ACTION_LOAD_PREGNANCY_TYPE] : apiHelper.mutateResult(
    apiLoadMortalityPregnancyType,
    MUTATE_MORTALITY_PREGNANCY_TYPE ),
  [ACTION_LOAD_INDICATIONS_FOR_CS] : apiHelper.mutateResult(
    apiLoadIndicationForCS,
    MUTATE_INDICATIONS_FOR_CS ),
  [ACTION_LOAD_DELIVERY_MANNER] : apiHelper.mutateResult(
    apiLoadDeliveryManner,
    MUTATE_DELIVERY_MANNER ),
  [ACTION_LOAD_AOG] : apiHelper.mutateResult(
    apiLoadAOG,
    MUTATE_AOG ),
  [ACTION_LOAD_ALL_PREGNANCY_TYPE] : apiHelper.mutateResult(
    apiLoadPregnancyType,
    MUTATE_PREGNANCY_TYPE ),

};

export default {
  state,
  getters,
  mutations,
  actions
}
